import axios from "axios";
import { getHeaders, URL } from "./config";
export const submitPOtoDnh = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToDnh`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const submitToIngram = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToIngram`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const submitPurchaseOrderToAsi = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToAsi`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
                success: false
            });
        });
};

export const submitToAsi = submitPurchaseOrderToAsi;

export const submitPurchaseOrderToTd = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToTd`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
                success: false
            });
        });
};

export const submitToTd = submitPurchaseOrderToTd;

export const submitPurchaseOrderToAccutech = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToAccutech`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
                success: false
            });
        });
};

export const submitToAccutech = submitPurchaseOrderToAccutech;

export const getDnhProductsByPartNumbers = async (items, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getDnhProductByPartNumbers?partNumber=${items}`;
    axios
        .post(url, {}, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const getIngramPriceAvailability = async (vpn, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/ingramPriceAvailability?vpn=${vpn}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const searchDistributorProducts = async (partNumber, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/searchDistributorProducts?query=${partNumber}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const getDnhOrderStatus = async (dnhOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getDnhOrderStatus?dnhOrderId=${dnhOrderId}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const getDistributorStock = async (skus, callback) => {
    const headers = await getHeaders();
    const skuParam = Array.isArray(skus) ? skus.filter(Boolean).join(",") : (skus || "");
    const url = `${URL}/getDistributorStock?skus=${encodeURIComponent(skuParam)}`;
    axios
        .get(url, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            axios
                .post(url, {}, { headers: headers })
                .then(async (response) => {
                    if (response?.data) {
                        callback({ status: 200, data: response?.data, success: true });
                    }
                })
                .catch((err2) => {
                    callback({ status: 400, message: err2?.response?.data?.message || err2?.message, success: false });
                });
        });
};

export const getJenneQuoteForPO = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getJenneQuoteForPO`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
                success: false,
            });
        });
};

export const submitPurchaseOrderToJenne = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToJenne`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
                success: false,
            });
        });
};

export const submitToJenne = submitPurchaseOrderToJenne;

export const submitPurchaseOrderToBluestar = async (purchaseOrderId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/submitPurchaseOrderToBluestar`;
    axios
        .post(url, { purchaseOrderId: purchaseOrderId }, { headers: headers })
        .then(async (response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data, success: true });
            }
        })
        .catch((error) => {
            callback({
                status: 400,
                message: error?.response?.data?.message || error?.message,
                success: false,
            });
        });
};

export const submitToBluestar = submitPurchaseOrderToBluestar;

